module.exports = __webpack_public_path__ + "static/media/BRY-BNB.6f719c10.svg";